import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swpleft",
  "use": "icon-swpleft-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-swpleft\"><path d=\"M713.77 185.173a42.667 42.667 0 0 1-3.925 60.246L406.06 511.957l-28.16-32.085 28.16 32.085L710.784 778.54a42.667 42.667 0 1 1-56.192 64.256L349.867 576.17a85.333 85.333 0 0 1-0.086-128.342l303.787-266.581a42.667 42.667 0 0 1 60.16 3.925z\" p-id=\"9020\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol